module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-styled-components@6.16.0_babel-plugin-styled-components@2.3.0_gatsby@5.16_d5c614cab8f7a82d11b3e7177d48489a/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_cssnano@5.1.15_csso@4.2.0_react-dom@19.3.0_react@19.3_50fd36fded708d1ef28bb12999ce580f/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
